import { render, staticRenderFns } from "./CreateTemplateDdProject.vue?vue&type=template&id=7ebe8608"
import script from "./CreateTemplateDdProject.vue?vue&type=script&lang=js"
export * from "./CreateTemplateDdProject.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateDdProject.vue?vue&type=style&index=0&id=7ebe8608&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports